/**
 * Resolves with the promise's value, or with `undefined` once `ms` have elapsed, whichever comes
 * first. The promise itself keeps running — this only bounds how long the caller waits for it.
 *
 * Total by construction: a rejection resolves to `undefined` rather than propagating, so a caller
 * awaiting this is never thrown into by work it only wanted to give a deadline to.
 */
export async function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T | undefined> {
	let timer: ReturnType<typeof setTimeout> | undefined;

	// eslint-disable-next-line promise/avoid-new
	const expiry = new Promise<undefined>((resolve) => {
		timer = setTimeout(() => resolve(undefined), ms);
	});

	try {
		return await Promise.race([
			promise.then(
				(value) => value,
				() => undefined,
			),
			expiry,
		]);
	} finally {
		clearTimeout(timer);
	}
}
